<template>
    <div :style="wrapperStyle" class="circle-trend-wrapper">
        <div :style="circleStyle" class="circle">{{title}}</div>
        <div :style="textStyle" class="text">
            <p :style="pStyle">{{total}}&nbsp;{{unit}}</p>
            <p :style="pStyle">{{pre}}&nbsp;{{plusMinus}}{{changeNumber}}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'circleTrend',
    props: {
        title: {
            type: String,
            default: '治愈'
        },
        total: {
            type: Number,
            default: 0
        },
        unit: {
            type: String,
            default: '例'
        },
        pre: {
            type: String,
            default: '昨日'
        },
        changeNumber: {
            type: Number,
            default: 0
        },
        fontObj: {
            type: Object
        },
        circleWidth: {
            type: Number
        },
        borderWidth: {
            type: Number
        },
        borderColor: {
            type: String
        }
    },
    computed: {
        plusMinus() {
            return this.changeNumber >= 0
            ? '+'
            : '';
        },
        wrapperStyle() {
            return this.fontObj
            ? Object.assign({}, this.fontObj, {
                fontSize: `${this.fontObj.fontSize}px`,
                color: `${this.fontObj.color}`,
                fontStyle: `${this.fontObj.fontStyle}`
            })
            : {}
        },
        circleStyle() {
            return this.borderWidth
            ? Object.assign({}, {
                width: `${this.circleWidth}px`,
                height: `${this.circleWidth}px`,
                lineHeight: `${this.circleWidth-this.borderWidth*2}px`,
                border: `${this.borderWidth}px solid ${this.borderColor}`
            })
            : {}
        },
        textStyle() {
            return this.borderWidth
            ? Object.assign({}, {
                paddingTop: `${this.borderWidth}px`,
            })
            : {}
        },
        pStyle() {
            return this.circleWidth && this.borderWidth
            ? Object.assign({}, {
                lineHeight: `${(this.circleWidth-this.borderWidth*2)/2}px`,
            })
            : {}
        }
    }
}
</script>

<style lang="less">
.circle-trend-wrapper {
    display: flex;
    font-size: 16px;
    justify-content: space-between;
    .circle {
        border: 10px solid royalblue;
        border-radius: 50%;
        width: 80px;
        height: 80px;
        text-align: center;
        line-height: 60px;
    }
    .text {
        padding: 10px;
        height: 80px;
        p {
            line-height: 30px;
        }
    }
}
</style>